export default __webpack_public_path__ + "static/media/background-texture_circles.eab74521.png";